import { CardWithStatus } from './types'

export const isActive = (card: CardWithStatus): boolean => {
  return card.status === 'active' && (!card.approval || card.approval.status === 'approved')
}
